import React, { Component } from 'react';
import { setTimeout } from 'core-js';
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";
import EirOnlineFormBuilder from '../eir-online-forms/EirOnlineFormBuilder';
let activeClass;

class EirHelpAndSupport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formReference: (this.props.formList != undefined) ? this.props.formList[0].formDetails.cmsContent : [],
      frequentFormSection: (this.props.frequentFormList != undefined) ? this.props.frequentFormList.frequentFormsArray : [],
      formsCategoriesList: [],
      leftMenuHeading: (this.props.frequentFormList != undefined) ? this.props.frequentFormList.LMsectionHeading : [],
      showUserInfoSummary: true,
      mobilePagination: false,
      showPagination: false,
      isBusinessSite: location.href.contains('/business/'),
    };
  }

  componentWillMount = () => {
    //below are the settings that are needed to be done as per the requirements without modifying the already existing component's code Ex: full width banner
    let fullWidthBanner = document.querySelector(".eir-fullwidth-banner");
    // console.log("fullWidthBanner >>>>>>>>>>>>>> " , fullWidthBanner);
    // console.log("props from helpandsupport >>>>>>>>>>>>>> " , this.props);
    if (fullWidthBanner != null) {
      let fullWidthBannerTitle = document.querySelector(".eir-title");
      let fullWidthBannerSubTitle = document.querySelector(".eir-text");
      let showFullWidthBanner = this.props.frequentFormList.FWBVisibile.toLowerCase();
      fullWidthBannerTitle.style.cssText = "font-size:30pt;color:" + this.props.frequentFormList.FWBFontColor;
      fullWidthBannerSubTitle.style.cssText = "width:58% !important;color:" + this.props.frequentFormList.FWBFontColor;
      (isMobileOnly && showFullWidthBanner === "desktop-only") ? fullWidthBanner.classList.add("hidden") : fullWidthBanner.classList.remove("hidden")
    }
    //hide breadcrumb for mobile
    if (isMobileOnly) document.querySelector(".eir-breadcrumb").classList.add("hidden");
    //the activeClass variable holds the style for the selected / active items - color related values defined in opencms
    activeClass = "background:" + this.props.frequentFormList.SelectedItemBG + ";color:" + this.props.frequentFormList.SelectedItemFG;


  }
  // Show the Frequently used forms in the top
  printFrequentFormsSection = () => {
    let frequentFormsList = [];
    for (let formItem in this.state.frequentFormSection) {
      var bgStyle = "";
      (!isMobileOnly) ?
        (
          bgStyle = {
            background: 'url(/opencms/export/sites/support' + this.state.frequentFormSection[formItem].formIcon + ') right no-repeat',
            backgroundSize: '125px 87px',
            backgroundPositionX: '95%'
          }
        ) : bgStyle = { fontFamily: 'inherit' }
      frequentFormsList.push(
        <div style={bgStyle} className="col-lg-4 col-md-6 col-sm-12 ff-item" tabIndex={0} onKeyDown={this.handleKeyPressfrequentForm} onClick={this.handleFormRender} id={this.state.frequentFormSection[formItem].formPath} key={"ff-item-outer" + formItem} role="link" title={this.state.frequentFormSection[formItem].formName}>
          <div className="ff-text col-lg-12" onKeyDown={this.handleKeyPressfrequentForm} onClick={this.handleFormRender} id={this.state.frequentFormSection[formItem].formPath} key={formItem}>
            <div className="frequentFormName">{this.state.frequentFormSection[formItem].formName}</div>
          </div>
          {/* <img src={"/opencms/export/sites/support"+this.state.frequentFormSection[formItem].formIcon} alt={this.state.frequentFormSection[formItem].formName} /> */}
          <i className={(isMobileOnly) ? "arrow right" : "hidden"}></i>
        </div>
      );
    }
    return frequentFormsList
  }

  // this will render the left menu items [forms lsit]
  printFormNamesLeftMenu = () => {
    let formNameList = [];
    let getSortedFormList = []; //this array is to hold the form list in the sorted by form name - for the items to be sorted alphabetically in left menu
    let activeCount = 0;
    for (let i in this.props.formList) {
      //filtering based on the site - consumer or business - EIRZWM-598
      //for business site forms - depends on the Category value [right click --> properties in /contents/eir-form-builder] of the created form in opencms - EIRZWM-598
      if (this.state.isBusinessSite && this.props.formList[i].formDetails.cmsContent.formSiteCategory.toLowerCase() === "business") {
        getSortedFormList.push(this.props.formList[i])
      }
      if (!this.state.isBusinessSite && this.props.formList[i].formDetails.cmsContent.formSiteCategory.toLowerCase() !== "business") {
        getSortedFormList.push(this.props.formList[i])
      }
    }
    //below will sort the getSortedFormList array alphabetically
    getSortedFormList.sort((a, b) => (a.formName > b.formName) ? 1 : ((b.formName > a.formName) ? -1 : 0));
    for (let formItem in getSortedFormList) {
      let appendParentCategory = "";
      if (getSortedFormList[formItem].FormCategory != undefined) {
        appendParentCategory = getSortedFormList[formItem].FormCategory;
      }
      //only active forms are to be rendered - depends on the NavPos value [right click --> properties in /contents/eir-form-builder] of the created form in opencms
      if (getSortedFormList[formItem].formDetails.cmsContent.formActive !== "hide") {
        activeCount++;
        formNameList.push(

          <li key={"list_item_" + formItem} tabIndex={0} onKeyDown={this.handleKeyPress} data-category={appendParentCategory} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOver} id={"leftmenu_active_" + activeCount}>
            <span role="link" data-path={getSortedFormList[formItem].formPath} className="leftmenu-list-item" onClick={this.handleFormRender} id={formItem} key={formItem}>{getSortedFormList[formItem].formName}</span>
            <i className={(!isMobileOnly) ? "arrow right" : "hidden"}></i>
          </li>
        )
        //added to test for mobile - to be removed  ------------ start 
        /* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        ***************************************************************************************************************************************
        ***************************************************************************************************************************************
        ***************************************************************************************************************************************
        */

        /*** added below to test the pagination */
        /*
        if(isMobileOnly) { 
        formNameList.push(
          <li key={"list_item_1_"+formItem} data-category={appendParentCategory} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOver} id={"leftmenu_active_"+activeCount}>
            <span role="link" className="leftmenu-list-item" onClick={this.handleFormRender} id={formItem} key={formItem}>{getSortedFormList[formItem].formName}</span>
            <i className={(!isMobileOnly) ? "arrow right" : "hidden"}></i>
          </li>
          )
          formNameList.push(
            <li key={"list_item_1_"+formItem} data-category={appendParentCategory} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOver} id={"leftmenu_active_"+activeCount}>
              <span role="link" className="leftmenu-list-item" onClick={this.handleFormRender} id={formItem} key={formItem}>{getSortedFormList[formItem].formName}</span>
              <i className={(!isMobileOnly) ? "arrow right" : "hidden"}></i>
            </li>
            )        
          }
          */
        //added to test for mobile - to be removed  ----------- end 
      }
    }
    return formNameList
  }

  //this is to show /hide the respective form names in the left menu --> on click of the category
  toggleFormCategory = (e) => {
    //on click of category section - first clear already selected item if any and make the bg,font for all items as default
    let selectedItem = document.querySelector(".selected-category");
    if (selectedItem != null && selectedItem.style.backgroundImage.indexOf("-light.png")) {
      selectedItem.style.cssText = "background: " + selectedItem.style.backgroundImage.replace("-light.png", "-dark.png") + " no-repeat #fff;color:" + this.props.frequentFormList.FFsectionFontColor + ";background-size:35px;background-size: 35px;background-position: 2% 45%;";
      selectedItem.childNodes[0].style.color = this.props.frequentFormList.FFsectionFontColor;
      selectedItem.classList.remove("selected-category");
    }

    //set a class for the selected item so that on click of next item, we get a reference of previously selected and can make that to default style 
    // and make the selected one to active
    let getBGImage = e.currentTarget.style.backgroundImage;
    e.currentTarget.classList.add("selected-category");
    let hoverBGImage = (getBGImage.indexOf("-dark.png") > 0) ? getBGImage.replace("-dark.png", "-light.png") : ''
    e.currentTarget.style.cssText = "background: " + e.currentTarget.style.backgroundImage.replace("-dark.png", "-light.png") + " no-repeat " + this.props.frequentFormList.SelectedItemBG + ";color:#fff;background-size:35px;background-position: 2% 45%;";

    // now starts the code for toggling of the left menu items 
    let getCatName = e.currentTarget.querySelector(".forms-category-name").innerText;
    this.setState({ leftMenuHeading: getCatName })
    let leftMenuItems = document.querySelector(".leftmenu-forms-list");
    for (let cnt = 0; cnt < leftMenuItems.childNodes.length; cnt++) {
      leftMenuItems.childNodes[cnt].classList.add("hidden");
      leftMenuItems.childNodes[cnt].classList.remove("selected-leftmenu-item");
      if (getCatName.toLowerCase() === "view all forms") {
        leftMenuItems.childNodes[cnt].classList.remove("hidden");
      }
      else {
        ((leftMenuItems.childNodes[cnt].getAttribute('data-category')).toLowerCase() == getCatName.toLowerCase()) ?
          (
            leftMenuItems.childNodes[cnt].classList.remove("hidden"),
            leftMenuItems.childNodes[cnt].classList.add("selected-leftmenu-item")
          )
          :
          '' // else condtion of ternary
      }
      // if single item is present in left menu - for mobile view to make it 100 percent width
      // if(document.querySelectorAll(".selected-leftmenu-item").length == 1) document.querySelector(".selected-leftmenu-item").classList.add("w-100");
    }
    //once the left menu is updated based on the form-category, then click the first item in the left menu
    for (let cnt = 0; cnt < leftMenuItems.childNodes.length; cnt++) {
      if (!leftMenuItems.childNodes[cnt].classList.contains("hidden")) {
        leftMenuItems.childNodes[cnt].childNodes[0].click();
        break;
      }
    }
    this.togglePaginationForMobile();
  }
  //this will pass the clicked form cmsContent to the Form Builder to render the form in the RHS
  //the formReference state contains the cmsContent - this is taken by comparing hte clicked item xml with
  handleFormRender = (e) => {
    if (e != undefined) {
      this.setState({ showUserInfoSummary: false })
      //if the user clicks on the Frequently used forms section
      //first click the view all forms category 
      ///* !!! *** DO NOT CHANGE THE View All Forms folder name in the opencms - as the validation is based on the name !!! *** */
      let formCategories = document.querySelectorAll(".forms-category-name");
      if (isNaN(parseInt(e.target.id))) {
        for (let cnt = 0; cnt < formCategories.length; cnt++) {
          if (formCategories[cnt].innerHTML.toLowerCase() === "view all forms") {
            formCategories[cnt].click(); // to get the selected / active item style for "view all forms" when clicked from freq. forms list
            formCategories[cnt].style.color = "#fff"
            break;
          }
        }
        // once the View All Forms is clicked,  match the respective form to be rendered
        //the match is done ---> as the id of the clicked item is the xml path, we match it with the formPath from props and click that item
        let getListItems = document.querySelectorAll(".leftmenu-list-item");
        // console.log("e.target >> ", e.target);

        for (let item in getListItems) {
          // console.log("item is >> ", item + "\n formPath >> " , getListItems[item].getAttribute("data-path") + "\n id >>> ", e.target.id);
          // console.log("data-path >>> " , getListItems[item].getAttribute("data-path") + "\n e.target.id >>> ", e.target.id);
          if ((getListItems[item] != undefined && getListItems[item].getAttribute("data-path")) === e.target.id) {
            var singleItemWidth = (window.innerWidth > 320) ? ((window.innerWidth <= 375) ? 150 : ((window.innerWidth > 400) ? 186 : 170)) : 140;
            var listItemRight = getListItems[item].getBoundingClientRect().right - singleItemWidth;
            // console.log("listItemRight >>>>>>>>>>>>>> ", listItemRight);
            //added a condition for mobile only - as we need to scroll to the  respective item in the form list
            (isMobileOnly) ? document.querySelector(".leftmenu-forms-list").style.transform = "translateX(-" + listItemRight + "px)" : ''
            getListItems[item].click();
            break;
          }
        }
        //scroll to the forms section
        document.querySelector(".form-related-section").scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      //if the user clics on the form names in the LHS
      else {
        //change the background and arrow color of the left menu item on click-
        let getListItems = document.querySelectorAll(".leftmenu-list-item");
        for (let item = 0; item < getListItems.length; item++) {
          getListItems[item].parentNode.style.cssText = "";
          getListItems[item].parentNode.querySelector("i").style.cssText = "";
          getListItems[item].parentNode.classList.remove("selected-form-item")
        }
        e.target.parentNode.classList.add("selected-form-item")
        e.target.parentNode.style.cssText = activeClass;
        e.target.parentNode.querySelector("i").style.borderColor = this.props.frequentFormList.SelectedItemFG;
        for (let itemCnt in this.props.formList) {
          if (this.props.formList[itemCnt].formName.toLowerCase() === e.target.innerHTML.toLowerCase()) {
            this.setState({ formReference: this.props.formList[itemCnt].formDetails.cmsContent })
            //scroll to the forms section
            document.querySelector(".form-related-section").scrollIntoView({ block: 'start', behavior: 'smooth' });
          }

        }


      }
    } else {
      this.setState({
        formReference: this.props.formList[0].formDetails.cmsContent
      })
    }
    
    setTimeout(() => {
      const fb = document.querySelector(".form-builder");
      if (fb && fb.focusFirstElement) {
          fb.focusFirstElement();
      }
  }, 50);

  }

  handleKeyPressfrequentForm = (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault(); // prevent page scroll on space
      this.handleFormRender(e);
      setTimeout(() => {
        const formBuilder = document.querySelector(".form-builder");
        if (formBuilder && formBuilder.focusFirstElement) {
          formBuilder.focusFirstElement();
        }
      }, 50);
    }
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault(); // prevent page scroll on space
    const item =
    e.target.classList.contains("leftmenu-list-item")
      ? e.target
      : e.target.querySelector(".leftmenu-list-item");
      if (item) {        
        item.click();
        setTimeout(() => {
          const formBuilder = document.querySelector(".form-builder");
          if (formBuilder && formBuilder.focusFirstElement) {
            formBuilder.focusFirstElement();
          }
        }, 50);
      }
    }
  }
  handleFormCategory = (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault(); // prevent page scroll on space
        this.toggleFormCategory(e);
        setTimeout(() => {
          const formBuilder = document.querySelector(".form-builder");
          if (formBuilder && formBuilder.focusFirstElement) {
            formBuilder.focusFirstElement();
          }
        }, 50);
    }
  }

  handleMouseOver = (e) => {
    //if - for the category lists items
    if (e.currentTarget.classList.contains("forms-category-item")) {
      if (!e.currentTarget.classList.contains("selected-category")) {
        let getBGImage = e.currentTarget.style.backgroundImage;
        let hoverBGImage = (getBGImage.indexOf("-dark.png") > 0) ? getBGImage.replace("-dark.png", "-light.png") : getBGImage.replace("-light.png", "-dark.png")
        e.type == "mouseover" ?
          (
            e.currentTarget.style.cssText = "background:" + hoverBGImage + " no-repeat " + this.props.frequentFormList.SelectedItemBG + ";color:" + this.props.frequentFormList.SelectedItemFG + ";background-size:35px;background-position: 2% 45%;",
            e.currentTarget.querySelector(".forms-category-name").style.cssText = ''
          )
          :
          (
            e.currentTarget.style.cssText = "background-image:" + hoverBGImage,
            e.currentTarget.querySelector(".forms-category-name").style.color = this.props.frequentFormList.FCsectionFontColor
          )
      } else {
        e.currentTarget.querySelector(".forms-category-name").style.color = "#fff" // to retain the font color(#fff) when multiple clicks happens on selected item
      }
    }
    //else is for  the left menu items
    else {
      if (!e.currentTarget.classList.contains("selected-form-item") && e.currentTarget.querySelector(".arrow") != null) {
        (e.type == "mouseover") ?
          (
            e.currentTarget.style.cssText = activeClass,
            e.currentTarget.querySelector(".arrow").style.cssText = "border:1px solid #fff;border-width:0 3px 3px 0"
          )
          :
          (
            e.currentTarget.style.cssText = "",
            e.currentTarget.querySelector(".arrow").style.cssText = ""
          )
      }
    }
  }
  componentDidMount = () => {
    //select the first category of the form item when page loads - commented as of now
    //document.querySelector(".forms-category-name").click();
    //document.querySelector(".forms-category-name").style.color = "#fff";
    this.setState({
      showUserInfoSummary: true,
      // mobilePagination : (document.querySelectorAll(".leftmenu-list-item").length > 8) ? true : false
    });
    //alignment of arrows in left menu if text runs into second line
    for (let cnt = 0; cnt < document.querySelectorAll(".leftmenu-list-item").length; cnt++) {
      (document.querySelectorAll(".leftmenu-list-item")[cnt].clientHeight > 50) ? document.querySelectorAll(".leftmenu-list-item")[cnt].nextElementSibling.classList.add("mt-2") : ''
    }
    this.togglePaginationForMobile();
    //load the respective form by accessing the query parameter
    let getFormName = new URLSearchParams(window.location.search).get('form');
    let leftMenuList = document.querySelectorAll(".leftmenu-list-item");
    for (var itemCnt = 0; itemCnt < leftMenuList.length; itemCnt++) {
      let formPath = leftMenuList[itemCnt].getAttribute("data-path");
      let extractFormRef = formPath.substr(formPath.lastIndexOf("/") + 1, formPath.length).split(".")[0];
     if (getFormName === extractFormRef) {
        setTimeout(() => {
                   leftMenuList[itemCnt].click();
                }, 300);
        
        break;
      }
    }

  }

  //the scrollFormList - is only for mobile view - wherein the user can scroll across to see the list of forms
  scrollFormList = (e) => {
    var getULElement = document.querySelector(".leftmenu-forms-list");
    var trans = 0;
    var vpWidth = window.innerWidth;
    var spaceParam, alignLeftParam;
    ;
    switch (true) {
      case ((vpWidth >= 320 && vpWidth < 359)): {
        // console.log("case 1");
        spaceParam = "89";
        alignLeftParam = "15";
        break;
      }
      case ((vpWidth >= 359 && vpWidth < 374)): {
        // console.log("case 2");
        spaceParam = "108";
        alignLeftParam = "18";
        break;
      }
      case (vpWidth >= 375 && vpWidth < 411): {
        // console.log("case 3");
        spaceParam = "114";
        alignLeftParam = "21";
        break;
      }
      case (vpWidth >= 411 && vpWidth <= 767): {
        // console.log("case 4");
        spaceParam = "131";
        alignLeftParam = "11";
        break;
      }
      default: {
        // console.log("case def");
        break;
      }
    }

    var scrollByParam, getLastItemRight = "";
    for (let activeItem in getULElement.childNodes) {
      // console.log("has hidden > " , ! getULElement.childNodes[activeItem].classList.contains("hidden"));
      if (getULElement.childNodes[activeItem].classList != undefined && !getULElement.childNodes[activeItem].classList.contains("hidden")) {
        //get the first item
        scrollByParam = ((getULElement.childNodes[activeItem].offsetWidth * 2) - spaceParam)

        //getLastItemRight will have the right co-oridnate of the last active item and then if user tries to scroll fwd, will navigate to first item
        if ((getULElement.childNodes[activeItem].nodeName === "LI")) {
          // console.log("right is >> ", getULElement.childNodes[activeItem].getBoundingClientRect());
          getLastItemRight = getULElement.childNodes[activeItem].getBoundingClientRect().right;
        }
      }
    }
    // console.log("scrollByParam > " , scrollByParam + "\ngetLastItemRight > ", getLastItemRight);
    // console.log("window.innerWidth >> ", window.innerWidth);
    // 
    var scrollForPrevParam = (getULElement.offsetWidth / 2) - alignLeftParam;

    //value 200 below arrived by calculating the width of the li plus margins  plus start position margin of 30(approx)
    (e.target.id === "lm-next") ?
      (getULElement.getClientRects()[0].right > -(getULElement.clientWidth) && getLastItemRight > 200) ?
        trans = getULElement.getClientRects()[0].left - scrollByParam
        :
        trans = 0

      :
      (getULElement.getClientRects()[0].left < 0) ?
        trans = parseInt(scrollForPrevParam) + (getULElement.getClientRects()[0].left)
        :
        trans = 0

    // console.log("trans >>>>>>>>>" , trans);
    getULElement.style.transform = "translateX(" + trans + "px)";
    getULElement.style.transition = "0.7s";

  }

  //to change the height of the left menu when items are less than 8
  togglePaginationForMobile = () => {
    if (isMobileOnly) {
      let keepCount = 0;
      let leftMenuList = document.querySelectorAll(".leftmenu-list-item");
      document.querySelector(".leftmenu-forms-list").style.cssText = "height:270px;transform:translateX(0)";
      for (let getCount in leftMenuList) {
        if (leftMenuList[getCount].classList != undefined) {
          (!leftMenuList[getCount].parentNode.classList.contains("hidden")) ? keepCount++ : ''
        }
      }
      // console.log("keepcount in mobile pagination >>> ", keepCount);
      this.setState({
        mobilePagination: (keepCount > 8) ? true : false
      });
      switch (true) {
        case (keepCount < 3): {
          document.querySelector(".leftmenu-forms-list").style.height = "90px";
          break;
        }
        case (keepCount >= 3 && keepCount < 5): {
          document.querySelector(".leftmenu-forms-list").style.height = "140px";
          break;
        }
        default: {
          document.querySelector(".leftmenu-forms-list").style.height = "270px";
          break;
        }
      }
    }
  }
  renderContent = (content) => {
    return { __html: content };
  }
  render() {
    const formCategories = this.props.frequentFormList.categoriesList;
    //as the same object used for both consumer, business - fliter them based on the isBusinessSite - EIRZWM-598

    // if (this.state.isBusinessSite && this.props.formList[i].formDetails.cmsContent.formSiteCategory.toLowerCase() === "business") {
    //   getSortedFormList.push(this.props.formList[i])
    // }
    // if (!this.state.isBusinessSite && this.props.formList[i].formDetails.cmsContent.formSiteCategory.toLowerCase() !== "business") {
    //   getSortedFormList.push(this.props.formList[i])
    // }

    if (this.state.isBusinessSite) {
      for (var key in formCategories) {
        if (formCategories.hasOwnProperty(key)) {
          if ((formCategories[key].categorySite !== "business" || formCategories[key].categoryVisible.toLowerCase() === "hide")) {
            delete formCategories[key]
          }
        }
      }
    } else {
      for (var key in formCategories) {
        if (formCategories.hasOwnProperty(key)) {
          if ((formCategories[key].categorySite === "business") || formCategories[key].categoryVisible.toLowerCase() === "hide") {
            delete formCategories[key]
          }
        }
      }
    }
    // console.log("formCategories >> ", typeof (formCategories));
    // console.log("formCategories >> ", (formCategories));
    return (
      <div className="wrapper__margin">
        <div className="container help-and-support-page">
          <div className="col-lg-12 frequent-forms-section" style={{ color: this.props.frequentFormList.FFsectionFontColor }}>
            <h2 style={{ color: this.props.frequentFormList.FFsectionFontColor }} className="text-center-heading">{this.props.frequentFormList.FFsectionHeading}</h2>
            <div className="frequent-forms-list col-lg-12">
              {this.printFrequentFormsSection()}
            </div>
          </div>
          <div className="forms-categories-section col-lg-12 text-center" >
            <h2 style={{ color: this.props.frequentFormList.LMsectionFontColor }} className="text-center-heading">{this.props.frequentFormList.FCsectionHeading}</h2>
            {formCategories != undefined && (Object.keys(formCategories).map(categoryItem => {
              return (
                <div key={categoryItem} tabIndex={0} id={"category_" + categoryItem} className="forms-category-item text-left" onKeyDown={this.handleFormCategory} onClick={this.toggleFormCategory} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOver}
                  style={{ backgroundImage: "url(" + formCategories[categoryItem].categoryIcon + ")" }}>
                  <div className="forms-category-name" role="link" title={"Category " + formCategories[categoryItem].categoryName} key={formCategories[categoryItem].categoryName} style={{ color: this.props.frequentFormList.FCsectionFontColor }}>{formCategories[categoryItem].categoryName}</div>
                </div>
              )
            }
            ))}
          </div>
          <div className="col-lg-12 form-related-section">
            <div className="col-lg-3 col-xs-12 col-sm-12 col-md-4 float-left leftmenu-section">
              <h3 style={{ color: this.props.frequentFormList.LMsectionFontColor }}>{this.state.leftMenuHeading}</h3>
              <ul className="leftmenu-forms-list">
                {this.printFormNamesLeftMenu()}
              </ul>
              {
                (isMobileOnly && this.state.mobilePagination) &&
                <ul className="leftmenu-scroller col-12">
                  <li className="text-right" id="lm-prev" onClick={this.scrollFormList}><i className="arrow left"></i></li>
                  <li className="text-left" id="lm-next" onClick={this.scrollFormList}><i className="arrow right"></i></li>
                </ul>
              }
            </div>
            <div className="col-lg-9 col-xs-12 col-sm-12 col-md-8 float-left forms-landing-section">
              {(!this.state.showUserInfoSummary) ?
                <EirOnlineFormBuilder isFromListPage={this.state.formReference} />
                :
                <div className="mb-5 mt-2 welcome-message">
                  <div dangerouslySetInnerHTML={this.renderContent(this.props.frequentFormList.WelcomeMessage)}></div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default EirHelpAndSupport;